import { useMutation, useQueryClient } from 'react-query';
import api from 'services/api.service';

export default function useProcessAIDocument() {
  const queryClient = useQueryClient();
  const currentUser = queryClient.getQueryData(['user.currentUser']);

  return useMutation(
    (data) => api.post('/transactions/ai-process', data),
    {
      onSuccess: () => {
        // Invalidate the company advanced fields as most likely there were new ones added in /ai-process
        queryClient.invalidateQueries(['company.advancedFields', currentUser?.company_id]);
      },
    },
  );
};
